<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/stockout">{{$t('stock_in_list')}}</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">{{title}} <span v-if="header.DocSourceNo">[{{header.DocSourceNo}}]</span></li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="save"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('branch')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.BranchId">
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-grou">
                                <label class="control-label blue">{{$t('receiver')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.EmployeeId">
                                        <option value=""></option>
                                        <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ ret.KhmerName }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('purchase_order_no')}}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="header.DocSourceNo" readonly/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="stockdate"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm table-grid no-bor">
                                <thead>
                                    <tr class="blue">
                                        <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                        <th>{{$t('item_name')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th style="width: 120px;">{{$t('uom')}}</th>
                                        <th style="width: 120px;">{{$t('qty')}}</th>
                                        <th style="width: 120px;">{{$t('qty_in')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in lines" :key="index">
                                        <td class="text-center">{{index + 1}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td class="cell-input"><input type="text" class="form-control form-control-sm" v-model="ret.Description" /></td>
                                        <td>{{ret.UomName}}</td>
                                        <td>{{ret.Quantity}}</td>
                                        <td class="cell-input"><input type="number" class="form-control form-control-sm" v-model="ret.QuantityIn" :disabled="ret.ItemId==''" /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            title: this.$t('request_stock_in'),
            branchs: [],
            header: {
                BranchId: '',
                DocSourceNo: '',
                DocSource: 'Order'
            },
            lines: [],
            employees: [],
            isCheck: false,
            stockdate: this.$now().format('YYYY-MM-DD'),
            action: 'stockin/save'
        }
    },
    created(){
        this.getBranch();
        this.getEmployee();
        var id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            this.findById(id);
        }
    },
    methods: {
        getBranch: async function() {
            var res = await this.$api().post('branch/list', { Limit: 0 });
            if(this.$isValid(res)){
                this.branchs = res.data.Data;
            }
        },
        save(){
            var loading = this.$loading.show();
            this.header.InDateAt = this.stockdate;
            var req = {
                StockIn: this.header,
                StockInLines: this.lines
            };
            this.$api().post(this.action, req).then(res => {
                if(this.$isValid(res)){
                    this.$router.push('/stockin');
                }
            }).finally(function() { loading.hide(); });
        },
        findById(id){
            var loading = this.$loading.show();
            this.$api().post('purchase/order/find', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    var data = res.data.Json;
                    this.header.DocSourceNo = data.Header.Num;
                    this.header.BranchId = data.Header.BranchId;
                    data.Lines.forEach(element => {
                        if((element.Quantity - element.ReceiveQty) > 0){
                            this.lines.push({
                                ItemId: element.ItemId,
                                ItemName: element.ItemName,
                                UomId: element.UomId,
                                UomName: element.UomName,
                                Quantity: element.Quantity,
                                QuantityIn: element.Quantity - element.ReceiveQty
                            });
                        }
                    });
                }
            }).finally(function() { loading.hide(); });
        },
        getEmployee: async function(){
            var res = await this.$api().post('employees', { Limit: 0 });
            if(this.$isValid(res)){
                this.employees = res.data.Data;
            }
        }
    }
}
</script>